import(/* webpackMode: "eager" */ "/app/apps/root/src/app/global-error.tsx");
